"use client";

import { GoogleGsiButton } from "./GoogleGsiButton";
import { AppleSignInButton } from "./AppleSignInButton";

interface OAuthButtonsProps {
  next?: string | null;
  intent?: "signup" | "login";
}

export function OAuthButtons({ next, intent = "login" }: OAuthButtonsProps) {
  return (
    <div className="mucka-auth-oauth">
      <GoogleGsiButton next={next} intent={intent} />
      <AppleSignInButton next={next} intent={intent} />
    </div>
  );
}
